import { useState } from 'react';
import { cn } from '../../utils';
import Gravatar from './Gravatar';
import UserInitial from './UserInitial';

export type Email = `${string}@${string}`;

type User = {
    email: Email;
};

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

type AvatarProps = {
    user: User;
    size?: AvatarSize;
    As?: 'button' | 'div';
};

export default function Avatar({
    As = 'button',
    user,
    size = 'md',
    ...rest
}: AvatarProps) {
    const [show, setShow] = useState(false);
    return (
        <>
            <As
                {...rest}
                className={cn(
                    'alli-relative alli-flex alli-h-8 alli-w-8 alli-place-content-center alli-items-center alli-rounded-full alli-text-white',
                    'focus:alli-outline-none focus-visible:alli-ring-2',
                    {
                        'alli-h-6 alli-w-6 alli-text-xs': size === 'sm',
                        'alli-h-8 alli-w-8 alli-text-sm': size === 'md',
                        'alli-h-10 alli-w-10 alli-text-base': size === 'lg',
                        'alli-h-12 alli-w-12 alli-text-base': size === 'xl',
                    },
                )}
                onClick={() => setShow(!show)}>
                <div className="alli-group alli-flex alli-items-center alli-rounded-full alli-text-sm alli-font-normal alli-leading-5">
                    <Gravatar
                        email={user.email}
                        defaultStyle="404"
                        size={size}
                        show={show}
                        fallback={
                            <UserInitial
                                size={size}
                                from={user.email}
                                show={show}
                            />
                        }
                    />
                </div>
            </As>
        </>
    );
}
